import React , {useEffect} from 'react'
import {getNoveltiesAction,getFiltersNoveltiesAction,getTagsAction} from '../redux/noveltiesDucks'


// -- Componentes -- //
import Main from '../components/novedades/main'
import Blogs from '../components/novedades/blogs'
import Contact from '../components/form'
import { useDispatch } from 'react-redux'


function ScrollToTopOnMount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
      return null;
}


function Novedades(){

  const dispatch = useDispatch()

  useEffect(() =>{
    dispatch(getNoveltiesAction())
    dispatch(getFiltersNoveltiesAction())
  },[])

    ScrollToTopOnMount()
    return(
        <div className="novedades">
          <div className="layout">
            <Main />
            <div className="content">
                <Blogs />
                <Contact />
            </div>
          </div>
        </div>
    )
}

export default Novedades
